export default "__VITE_ASSET__DzgAS3PQ__"